import React from 'react'
import './stylesHome.css';
import logo from '../assets/logo-mitad.png'
import { Box, Container, Grid, Card, CardContent, Typography } from '@mui/material';
import { ReactComponent as LogoSVG } from '../assets/logo-animado-x2.svg';
import Image from 'mui-image'
import Footer from './Footer';
import TopNavigation from './TopNavigation';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import InfoIcon from '@mui/icons-material/Info';
import BarChartIcon from '@mui/icons-material/BarChart';
import GavelIcon from '@mui/icons-material/Gavel';

import { Link } from "react-router-dom";
import ArticleIcon from '@mui/icons-material/Article';
import { IconButton } from '@mui/material'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'

const Home = () => {
  const [tab, setTab] = React.useState('1');

  const handleChange = (event, newValue) => {
    setTab(newValue);
  };

  return (
    <>
      <TopNavigation />

      <div className='banner'>
        <Container maxWidth="xl">
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LogoSVG />
            <Image src={logo} duration={5000} />
          </Box>
        </Container>
        <br />
        <center><IconButton
          color="primary"
          size="large"
          onClick={() => {
            const element = document.getElementById('seccion-inferior')
            if (element) {
              element.scrollIntoView({ behavior: 'smooth' })
            }
          }}
        >
          <ArrowDownwardIcon fontSize="inherit" />
        </IconButton></center>

        <br id='seccion-inferior' />
        <Container maxWidth="lg" >
          <div style={{ position: 'relative', width: '100%' }}>
            {/* Mensaje de bienvenida */}
            <Box
              sx={{
                display: 'flex',
                alignItems: 'flex-start',
                gap: 4,
                flexDirection: { xs: 'column', md: 'row' },
                maxWidth: '1200px',
                mx: 'auto',
                my: 6,
                px: 2,
              }}
            >
              {/* Texto informativo */}
              <Box
                sx={{
                  backgroundColor: '#f9fafc',
                  p: 5,
                  borderRadius: 4,
                  boxShadow: 3,
                  flex: 1,
                  textAlign: 'justify',
                  lineHeight: 1.8,
                }}
              >
                <Typography
                  variant="h4"
                  gutterBottom
                  sx={{ fontWeight: 'bold', textAlign: 'center', mb: 3, color: '#081d4b' }}
                >
                  ¿Qué es Contratos Abiertos?
                </Typography>

                <Typography variant="body1" paragraph sx={{ color: '#333' }}>
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    Contratos Abiertos
                  </Box>{' '}
                  es un proyecto creado por el{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    Laboratorio de Tecnologías Sociales
                  </Box>{' '}
                  con el objetivo de mejorar la transparencia y accesibilidad de las contrataciones estatales en Bolivia. El proyecto se enfoca en proporcionar información clara y procesable sobre los contratos estatales, permitiendo que cualquier ciudadano pueda conocer y monitorear el uso de los recursos públicos.
                </Typography>

                <Typography variant="body1" paragraph sx={{ color: '#333' }}>
                  Para alcanzar este objetivo, Contratos Abiertos cuenta con apartados que incluyen varias herramientas y recursos. En primer lugar, la plataforma ofrece una lista de contratos estatales, disponible para su descarga y análisis. Además, cuenta con herramientas para extraer y procesar datos de{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    SICOES
                  </Box>
                  , el sistema de información de contrataciones estatales en Bolivia, y también proporciona datos específicos sobre los contratos de{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    Covid-19
                  </Box>{' '}
                  en Bolivia desde 2020 hasta 2022.
                </Typography>

                <Typography variant="body1" paragraph sx={{ color: '#333' }}>
                  Además de estos recursos, Contratos Abiertos incluye una serie de{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    notas estadísticas
                  </Box>{' '}
                  y{' '}
                  <Box component="span" sx={{ fontWeight: 'bold', color: '#081d4b' }}>
                    dateros
                  </Box>{' '}
                  que permiten explorar visualmente tendencias clave en los procesos de contratación pública.
                </Typography>
              </Box>
            </Box>

            <br />
            {/* Cards */}
            <Grid container spacing={4}>
              {/* Notas Informativas */}
              <Grid item xs={12} md={3}>
                <Link to="/notass" className="options-del-nav-bar">
                  <Card
                    sx={{
                      p: 3,
                      borderRadius: 4,
                      boxShadow: 4,
                      height: '70%',
                      transition: '0.3s',
                      '&:hover': {
                        transform: 'translateY(-10px)',
                        boxShadow: 8,
                        backgroundColor: '#f0f4ff',
                      },
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <InfoIcon sx={{ fontSize: 60, mr: 2, color: '#081d4b' }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                          Notas Informativas
                        </Typography>
                      </Box>
                      <Typography variant="body1" color="text.secondary">
                        Infórmate sobre contrataciones públicas con notas estadísticas de interés.
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>

              {/* Nueva: Notas Periodísticas */}
              <Grid item xs={12} md={3}>
                <Link to="/notas" className="options-del-nav-bar">
                  <Card
                    sx={{
                      p: 3,
                      borderRadius: 4,
                      boxShadow: 4,
                      height: '70%',
                      transition: '0.3s',
                      '&:hover': {
                        transform: 'translateY(-10px)',
                        boxShadow: 8,
                        backgroundColor: '#f0f4ff',
                      },
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <ArticleIcon sx={{ fontSize: 60, mr: 2, color: '#081d4b' }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                          Notas Periodísticas
                        </Typography>
                      </Box>
                      <Typography variant="body1" color="text.secondary">
                        Revisa noticias relevantes basadas en datos de contratación pública.
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>

              {/* Estadísticas de Contrataciones */}
              <Grid item xs={12} md={3}>
                <Link to="/estadisticas" className="options-del-nav-bar">
                  <Card
                    sx={{
                      p: 3,
                      borderRadius: 4,
                      boxShadow: 4,
                      height: '70%',
                      transition: '0.3s',
                      '&:hover': {
                        transform: 'translateY(-10px)',
                        boxShadow: 8,
                        backgroundColor: '#f0f4ff',
                      },
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <BarChartIcon sx={{ fontSize: 60, mr: 2, color: '#081d4b' }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                          Estadísticas de Licitaciones
                        </Typography>
                      </Box>
                      <Typography variant="body1" color="text.secondary">
                        Explora visualizaciones interactivas sobre montos adjudicados.
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>

              {/* Herramientas de Datos */}
              <Grid item xs={12} md={3}>
                <Link to="/herramientas" className="options-del-nav-bar">
                  <Card
                    sx={{
                      p: 3,
                      borderRadius: 4,
                      boxShadow: 4,
                      height: '70%',
                      transition: '0.3s',
                      '&:hover': {
                        transform: 'translateY(-10px)',
                        boxShadow: 8,
                        backgroundColor: '#f0f4ff',
                      },
                    }}
                  >
                    <CardContent>
                      <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                        <GavelIcon sx={{ fontSize: 60, mr: 2, color: '#081d4b' }} />
                        <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                          Herramientas de Datos
                        </Typography>
                      </Box>
                      <Typography variant="body1" color="text.secondary">
                        Encuentra herramientas de extracción y limpieza de datos.
                      </Typography>
                    </CardContent>
                  </Card>
                </Link>
              </Grid>


            </Grid>


            <br />
          </div>
          <br />
        </Container>
      </div>

      <Footer />
    </>
  );
};

export default Home;
